// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.date-range-picker {
    width: 100%;
    max-width: 420px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.date-range-picker__toggle {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    margin: 0;
    padding: 10px 12px;
    border-radius: 14px;
    border: 1px solid color-mix(in srgb, var(--brand-primary, #0877BC) 28%, var(--border-color, #e2e8f0));
    background:
      linear-gradient(
        135deg,
        color-mix(in srgb, var(--brand-primary, #0877BC) 10%, var(--surface-color, #fff)) 0%,
        var(--surface-color, #fff) 70%
      );
    color: var(--text-color, #0f172a);
    box-shadow: 0 6px 18px color-mix(in srgb, var(--brand-primary, #0877BC) 12%, transparent);
    cursor: pointer;
    text-align: left;
    font: inherit;
    -webkit-tap-highlight-color: transparent;
    transition: border-color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;
}

.date-range-picker__toggle:hover {
    border-color: color-mix(in srgb, var(--brand-primary, #0877BC) 48%, var(--border-color, #e2e8f0));
    box-shadow: 0 10px 24px color-mix(in srgb, var(--brand-primary, #0877BC) 18%, transparent);
    transform: translateY(-1px);
}

.date-range-picker__toggle:focus-visible {
    outline: 2px solid var(--brand-primary, #0877BC);
    outline-offset: 2px;
}

.date-range-picker__icon {
    flex: 0 0 auto;
    color: var(--brand-primary, #0877BC);
}

.date-range-picker__copy {
    min-width: 0;
    flex: 1 1 auto;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: baseline;
    gap: 8px;
}

.date-range-picker__kicker {
    flex: 0 1 auto;
    font-family: Poppins, system-ui, sans-serif;
    font-size: 15px;
    font-weight: 600;
    line-height: 28px;
    letter-spacing: normal;
    text-transform: none;
    color: var(--text-color, #202226);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.date-range-picker__value {
    flex: 0 0 auto;
    font-family: Poppins, system-ui, sans-serif;
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
    color: var(--brand-primary, #0877BC);
    white-space: nowrap;
}

.date-range-picker__chevron {
    flex: 0 0 auto;
    color: var(--text-secondary, #64748b);
    transition: transform 0.2s ease;
}

.date-range-picker.is-expanded .date-range-picker__chevron {
    transform: rotate(180deg);
}

.date-range-picker__panel {
    width: 100%;
    animation: dateRangePanelIn 0.22s ease both;
}

@keyframes dateRangePanelIn {
    from {
        opacity: 0;
        transform: translateY(-6px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@media (prefers-reduced-motion: reduce) {
    .date-range-picker__toggle,
    .date-range-picker__chevron,
    .date-range-picker__panel {
        transition: none;
        animation: none;
    }
}

.rdrDateRangePickerWrapper,
.rdrCalendarWrapper {
    width: 100%;
    border-radius: 8px;
    background: var(--surface-color, #fff);
    color: var(--text-color, #343339);
}

.rdrMonth {
    width: 100%;
    border-radius: 10px;
}

.rdrMonthAndYearPickers {
    font-weight: 600;
    font-size: 16px;
    color: var(--brand-primary, #0877BC);
}

.rdrWeekDay {
    font-weight: 800 !important;
    color: var(--text-secondary, #343339) !important;
}

.rdrDayNumber span {
    color: var(--text-color, #343339) !important;
}

.rdrNextPrevButton {
    background: var(--surface-color, #f3f8fa);
    border-radius: 50% !important;
}

.rdrNextButton i {
    border-color: transparent transparent transparent var(--brand-primary, #0877BC) !important;
}

.rdrPprevButton i {
    border-color: transparent var(--brand-primary, #0877BC) transparent transparent !important;
}

.rdrStartEdge,
.rdrEndEdge,
.rdrSelected,
.rdrDayStartPreview,
.rdrDayEndPreview,
.rdrDayInPreview {
    color: var(--brand-primary, #0877BC) !important;
}

/* Brand border on selected calendar day */
.rdrDay.rdrDaySelected .rdrDayNumber span,
.rdrDay.rdrDayStartOfRange .rdrDayNumber span,
.rdrDay.rdrDayEndOfRange .rdrDayNumber span {
    border: 2px solid var(--brand-primary, #0877BC) !important;
    border-radius: 50%;
    box-sizing: border-box;
}

.rdrInRange {
    /* soft brand tint for in-range background */
    color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.14) !important;
}

.rdrDefinedRangesWrapper {
    display: none;
}

/* Ensure selected day number is readable on brand background */
.rdrDay.rdrDaySelected .rdrDayNumber span,
.rdrDay.rdrDayStartOfRange .rdrDayNumber span,
.rdrDay.rdrDayEndOfRange .rdrDayNumber span {
    color: #fff !important;
    font-weight: 700;
}

/* Brand accent for hover/preview (when supported by react-date-range) */
.rdrDay.rdrDayHovered .rdrDayNumber span,
.rdrDay.rdrDayPassive .rdrDayNumber span:hover {
    color: var(--brand-primary, #0877BC) !important;
}

.rdrDayNumber span.rdrDayAgenda {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 2.1em;
    line-height: 1.1;
    border: none !important;
    background: transparent !important;
    color: inherit !important;
    font-weight: inherit;
}

.rdrDay.rdrDaySelected .rdrDayNumber span.rdrDayAgenda {
    color: #fff !important;
}

.rdrDayAgendaDots {
    display: flex;
    gap: 3px;
    height: 6px;
    margin-top: 2px;
}

.rdrDayAgendaDots--empty {
    visibility: hidden;
}

.rdrDayAgendaDot {
    width: 5px;
    height: 5px;
    border-radius: 50%;
}

.rdrDayAgendaDot--group {
    background: var(--brand-primary, #0877BC);
}

.rdrDayAgendaDot--private {
    background: var(--brand-secondary, #46528b);
}

.rdrDay.rdrDaySelected .rdrDayAgendaDot--group,
.rdrDay.rdrDaySelected .rdrDayAgendaDot--private {
    background: #fff;
}`, "",{"version":3,"sources":["webpack://./src/components/DateRange.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,qGAAqG;IACrG;;;;;OAKG;IACH,iCAAiC;IACjC,yFAAyF;IACzF,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,wCAAwC;IACxC,gFAAgF;AACpF;;AAEA;IACI,iGAAiG;IACjG,0FAA0F;IAC1F,2BAA2B;AAC/B;;AAEA;IACI,gDAAgD;IAChD,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,oCAAoC;AACxC;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,qBAAqB;IACrB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,2CAA2C;IAC3C,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,oBAAoB;IACpB,iCAAiC;IACjC,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,2CAA2C;IAC3C,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,oCAAoC;IACpC,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,qCAAqC;IACrC,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,2CAA2C;AAC/C;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;;;QAGI,gBAAgB;QAChB,eAAe;IACnB;AACJ;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,sCAAsC;IACtC,iCAAiC;AACrC;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,oCAAoC;AACxC;;AAEA;IACI,2BAA2B;IAC3B,gDAAgD;AACpD;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,yCAAyC;IACzC,6BAA6B;AACjC;;AAEA;IACI,0FAA0F;AAC9F;;AAEA;IACI,0FAA0F;AAC9F;;AAEA;;;;;;IAMI,+CAA+C;AACnD;;AAEA,0CAA0C;AAC1C;;;IAGI,0DAA0D;IAC1D,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,4CAA4C;IAC5C,mEAAmE;AACvE;;AAEA;IACI,aAAa;AACjB;;AAEA,+DAA+D;AAC/D;;;IAGI,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA,wEAAwE;AACxE;;IAEI,+CAA+C;AACnD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,kCAAkC;IAClC,yBAAyB;IACzB,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;;IAEI,gBAAgB;AACpB","sourcesContent":[".date-range-picker {\n    width: 100%;\n    max-width: 420px;\n    margin: 0 auto;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.date-range-picker__toggle {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    width: 100%;\n    margin: 0;\n    padding: 10px 12px;\n    border-radius: 14px;\n    border: 1px solid color-mix(in srgb, var(--brand-primary, #0877BC) 28%, var(--border-color, #e2e8f0));\n    background:\n      linear-gradient(\n        135deg,\n        color-mix(in srgb, var(--brand-primary, #0877BC) 10%, var(--surface-color, #fff)) 0%,\n        var(--surface-color, #fff) 70%\n      );\n    color: var(--text-color, #0f172a);\n    box-shadow: 0 6px 18px color-mix(in srgb, var(--brand-primary, #0877BC) 12%, transparent);\n    cursor: pointer;\n    text-align: left;\n    font: inherit;\n    -webkit-tap-highlight-color: transparent;\n    transition: border-color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;\n}\n\n.date-range-picker__toggle:hover {\n    border-color: color-mix(in srgb, var(--brand-primary, #0877BC) 48%, var(--border-color, #e2e8f0));\n    box-shadow: 0 10px 24px color-mix(in srgb, var(--brand-primary, #0877BC) 18%, transparent);\n    transform: translateY(-1px);\n}\n\n.date-range-picker__toggle:focus-visible {\n    outline: 2px solid var(--brand-primary, #0877BC);\n    outline-offset: 2px;\n}\n\n.date-range-picker__icon {\n    flex: 0 0 auto;\n    color: var(--brand-primary, #0877BC);\n}\n\n.date-range-picker__copy {\n    min-width: 0;\n    flex: 1 1 auto;\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    align-items: baseline;\n    gap: 8px;\n}\n\n.date-range-picker__kicker {\n    flex: 0 1 auto;\n    font-family: Poppins, system-ui, sans-serif;\n    font-size: 15px;\n    font-weight: 600;\n    line-height: 28px;\n    letter-spacing: normal;\n    text-transform: none;\n    color: var(--text-color, #202226);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.date-range-picker__value {\n    flex: 0 0 auto;\n    font-family: Poppins, system-ui, sans-serif;\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 22px;\n    color: var(--brand-primary, #0877BC);\n    white-space: nowrap;\n}\n\n.date-range-picker__chevron {\n    flex: 0 0 auto;\n    color: var(--text-secondary, #64748b);\n    transition: transform 0.2s ease;\n}\n\n.date-range-picker.is-expanded .date-range-picker__chevron {\n    transform: rotate(180deg);\n}\n\n.date-range-picker__panel {\n    width: 100%;\n    animation: dateRangePanelIn 0.22s ease both;\n}\n\n@keyframes dateRangePanelIn {\n    from {\n        opacity: 0;\n        transform: translateY(-6px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .date-range-picker__toggle,\n    .date-range-picker__chevron,\n    .date-range-picker__panel {\n        transition: none;\n        animation: none;\n    }\n}\n\n.rdrDateRangePickerWrapper,\n.rdrCalendarWrapper {\n    width: 100%;\n    border-radius: 8px;\n    background: var(--surface-color, #fff);\n    color: var(--text-color, #343339);\n}\n\n.rdrMonth {\n    width: 100%;\n    border-radius: 10px;\n}\n\n.rdrMonthAndYearPickers {\n    font-weight: 600;\n    font-size: 16px;\n    color: var(--brand-primary, #0877BC);\n}\n\n.rdrWeekDay {\n    font-weight: 800 !important;\n    color: var(--text-secondary, #343339) !important;\n}\n\n.rdrDayNumber span {\n    color: var(--text-color, #343339) !important;\n}\n\n.rdrNextPrevButton {\n    background: var(--surface-color, #f3f8fa);\n    border-radius: 50% !important;\n}\n\n.rdrNextButton i {\n    border-color: transparent transparent transparent var(--brand-primary, #0877BC) !important;\n}\n\n.rdrPprevButton i {\n    border-color: transparent var(--brand-primary, #0877BC) transparent transparent !important;\n}\n\n.rdrStartEdge,\n.rdrEndEdge,\n.rdrSelected,\n.rdrDayStartPreview,\n.rdrDayEndPreview,\n.rdrDayInPreview {\n    color: var(--brand-primary, #0877BC) !important;\n}\n\n/* Brand border on selected calendar day */\n.rdrDay.rdrDaySelected .rdrDayNumber span,\n.rdrDay.rdrDayStartOfRange .rdrDayNumber span,\n.rdrDay.rdrDayEndOfRange .rdrDayNumber span {\n    border: 2px solid var(--brand-primary, #0877BC) !important;\n    border-radius: 50%;\n    box-sizing: border-box;\n}\n\n.rdrInRange {\n    /* soft brand tint for in-range background */\n    color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.14) !important;\n}\n\n.rdrDefinedRangesWrapper {\n    display: none;\n}\n\n/* Ensure selected day number is readable on brand background */\n.rdrDay.rdrDaySelected .rdrDayNumber span,\n.rdrDay.rdrDayStartOfRange .rdrDayNumber span,\n.rdrDay.rdrDayEndOfRange .rdrDayNumber span {\n    color: #fff !important;\n    font-weight: 700;\n}\n\n/* Brand accent for hover/preview (when supported by react-date-range) */\n.rdrDay.rdrDayHovered .rdrDayNumber span,\n.rdrDay.rdrDayPassive .rdrDayNumber span:hover {\n    color: var(--brand-primary, #0877BC) !important;\n}\n\n.rdrDayNumber span.rdrDayAgenda {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    min-height: 2.1em;\n    line-height: 1.1;\n    border: none !important;\n    background: transparent !important;\n    color: inherit !important;\n    font-weight: inherit;\n}\n\n.rdrDay.rdrDaySelected .rdrDayNumber span.rdrDayAgenda {\n    color: #fff !important;\n}\n\n.rdrDayAgendaDots {\n    display: flex;\n    gap: 3px;\n    height: 6px;\n    margin-top: 2px;\n}\n\n.rdrDayAgendaDots--empty {\n    visibility: hidden;\n}\n\n.rdrDayAgendaDot {\n    width: 5px;\n    height: 5px;\n    border-radius: 50%;\n}\n\n.rdrDayAgendaDot--group {\n    background: var(--brand-primary, #0877BC);\n}\n\n.rdrDayAgendaDot--private {\n    background: var(--brand-secondary, #46528b);\n}\n\n.rdrDay.rdrDaySelected .rdrDayAgendaDot--group,\n.rdrDay.rdrDaySelected .rdrDayAgendaDot--private {\n    background: #fff;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
